import { FilterCount, FilterSection } from "@flights/search-ui";
import React from "react";
import { useAirportsFilterController } from "./useAirportsFilter.controller.js";
import { InputCheckbox, Stack, Text } from "@bookingcom/bui-react";
import { useTrackLayoverPriceAirportFilterWeb } from "../../../../../utils/experiments/funnel/flights_funnel_layover_price_airport_filter_web.js";
import kebabCase from "lodash/kebabCase.js";
export const AirportsFilter = () => {
    const { isFilterAvailable, title, options, value, onChange } = useAirportsFilterController();
    const trackLayoverPriceAirportFilterWeb = useTrackLayoverPriceAirportFilterWeb();
    if (!isFilterAvailable || !options?.length)
        return null;
    return (React.createElement(FilterSection, { attributes: { "data-testid": "airports_filter" }, title: {
            text: title,
            tagName: "h3",
            attributes: { id: "airports_filter" },
            variant: "strong_2"
        } },
        React.createElement(Stack, { gap: 4 }, options?.map((option) => {
            const id = `airport_filter_${kebabCase(option.city)}`;
            return (React.createElement(Stack, { key: option.city, gap: 2, attributes: { role: "group", "aria-labelledby": id } },
                React.createElement(Text, { variant: "emphasized_2", tagName: "h4", attributes: {
                        "data-testid": `search_filter_airports_${option.city}`,
                        id: id
                    } }, option.city),
                option.airports.map((airport) => {
                    const countId = `${airport.iata}-${airport.count}`;
                    return (React.createElement(FilterCount, { key: airport.iata, count: airport.count, variant: trackLayoverPriceAirportFilterWeb() ? "small_1" : undefined, attributes: { id: countId } },
                        React.createElement(InputCheckbox, { label: React.createElement(Text, { variant: "body_2" },
                                React.createElement("b", null, airport.iata),
                                " ",
                                airport.name), value: airport.iata, name: `airports-filter-${airport.iata}`, checked: value.some((val) => val.iata === airport.iata), onChange: ({ checked }) => onChange(checked, airport.iata), attributes: {
                                "data-testid": `search_filter_airports_${airport.name}`
                            }, inputAttributes: { "aria-describedby": countId } })));
                })));
        }))));
};
export default AirportsFilter;
